/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldSecurity } from './fieldSecurity';


/**
 * Method data
 */
export interface MethodData { 
    /**
     * Method id
     */
    id: number;
    /**
     * Method name
     */
    name: string;
    /**
     * Picture
     */
    pictureName?: string | null;
    /**
     * Show the form before opening the method or not in the statement
     */
    dialogO: boolean;
    /**
     * Show form before executing method in client
     */
    dialogC: boolean;
    /**
     * Available for operator
     */
    availableO: boolean;
    /**
     * Available for client
     */
    availableC: boolean;
    /**
     * Are there restrictions on the availability of fields for operator
     */
    fieldSO: boolean;
    /**
     * Are there restrictions on the availability of fields for client
     */
    fieldSC: boolean;
    /**
     * list of field restrictions (visibility and accessibility)
     */
    fieldSecurities?: Array<FieldSecurity> | null;
    /**
     * Method is disabled
     */
    isDisabled?: boolean;
    /**
     * Source folder
     */
    sourceFolder?: number | null;
}

